import { INTERACTION_TYPES } from '@cult/domain';
import { z } from 'zod';
import { CursorPageSchema, CursorQuerySchema, SORT_ORDERS, SortOrderSchema, idMultiField, qField } from './common';
import { PublicDirectFeedbackSchema } from './direct-feedback';
import { PublicPraiseSchema } from './praises';

export const INTERACTION_TABS = {
  RECEIVED: 'received',
  GIVEN: 'given',
} as const;
export type InteractionTab = (typeof INTERACTION_TABS)[keyof typeof INTERACTION_TABS];
export const INTERACTION_TAB_VALUES = Object.values(INTERACTION_TABS) as [InteractionTab, ...InteractionTab[]];

export const INTERACTION_TYPE_FILTERS = {
  ALL: 'all',
  ...INTERACTION_TYPES,
} as const;
export type InteractionTypeFilter = (typeof INTERACTION_TYPE_FILTERS)[keyof typeof INTERACTION_TYPE_FILTERS];
export const INTERACTION_TYPE_FILTER_VALUES = Object.values(INTERACTION_TYPE_FILTERS) as [
  InteractionTypeFilter,
  ...InteractionTypeFilter[],
];

export const InteractionListQuerySchema = CursorQuerySchema.extend({
  tab: z.enum(INTERACTION_TAB_VALUES),
  type: z.enum(INTERACTION_TYPE_FILTER_VALUES).default(INTERACTION_TYPE_FILTERS.ALL),
  // Only praises carry core values and frameworks, so any selection narrows the feed to praises.
  coreValues: idMultiField,
  frameworks: idMultiField,
  q: qField,
  order: SortOrderSchema.default(SORT_ORDERS.DESC),
});
export type InteractionListQuery = z.infer<typeof InteractionListQuerySchema>;

export const InteractionItemSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal(INTERACTION_TYPES.PRAISE), praise: PublicPraiseSchema }),
  z.object({ type: z.literal(INTERACTION_TYPES.DIRECT_FEEDBACK), feedback: PublicDirectFeedbackSchema }),
]);
export type InteractionItem = z.infer<typeof InteractionItemSchema>;

export const InteractionListResponseSchema = CursorPageSchema.extend({
  items: z.array(InteractionItemSchema),
});
export type InteractionListResponse = z.infer<typeof InteractionListResponseSchema>;
